import { Button, Card, Flex, Space, Typography, theme } from "antd"
import { MapPin } from "ui/Icon/DSIcon/MapPin"
import PropTypes from "prop-types"
import { getStyles } from "./styles"

const { Text } = Typography
const { useToken } = theme

export const LocationCard = ({ meetingLatLng, onEdit, t }) => {
  const { token } = useToken()
  const styles = getStyles(token)

  const handleEditClick = (e) => {
    onEdit?.()
  }

  return (
    <Card className="cursor-pointer" styles={{ body: styles.cardBody }} style={styles.card}>
      <Flex align="center" gap="middle">
        <Flex align="center" justify="center" style={styles.imageContainer}>
          <MapPin className={styles.mapElement} fill={token.colorPrimary} style={styles.defaultImage} />
        </Flex>
        <div className="flex-grow-1">
          <Text strong className="d-block">
            {meetingLatLng}
          </Text>
        </div>
        <Space size="middle">
          <Button type="primary" onClick={handleEditClick} className={styles.editButton}>
            {t("global.edit")}
          </Button>
        </Space>
      </Flex>
    </Card>
  )
}

LocationCard.propTypes = {
  meetingLatLng: PropTypes.string,
  onEdit: PropTypes.func,
  t: PropTypes.func
}
